import SFCookieConsent from 'sfcookieconsent';
import consentTypes from 'sfcookieconsent/src/helpers/consentTypes';
import markupTypes from 'sfcookieconsent/src/helpers/markupTypes';

/* eslint-disable camelcase */
import de_DE from './languages/de_DE';
import en_US from './languages/en_US';

const customConfig = {
    availableConsentTypes: [
        consentTypes.CONSENT_TYPE_NECESSARY,
        consentTypes.CONSENT_TYPE_STATISTICS,
    ],
    externalCookieNames: {
        statistics: ['_g'],
    },
    translation: {
        defaultTranslation: 'en_US',
        dataAttributeName: 'sfcctranslation',
    },
    markupType: markupTypes.MARKUP_DEFAULT,
    enableGTMOnMarketing: true,
};

const customTranslation = {
    de_DE,
    en_US,
};

const customStyleConfig = {
    submitButton: { overrideDefaultClasses: true, customClassNames: 'button' },
    submitAllButton: { overrideDefaultClasses: true, customClassNames: 'button button--cta' },
};

const sfCookieConsent = new SFCookieConsent(customConfig, customTranslation, customStyleConfig);
export default sfCookieConsent;
